import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SyllabusQuery, SyllabusService } from '@examdojo/category/v2';
import { QuestionEntityService } from '@examdojo/question';
import { catchError, first, of, switchMap } from 'rxjs';
import { CmsUrlParts } from '../cms/cms.model';

export const legacyQuestionRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const questionService = inject(QuestionEntityService);
  const syllabusService = inject(SyllabusService);
  const syllabusQuery = inject(SyllabusQuery);

  const questionId: string = route.params['id'];

  if (!questionId) {
    return router.createUrlTree([`/${CmsUrlParts.Overview}`]);
  }

  return syllabusService.fetchSyllabuses().pipe(
    first(),
    switchMap(() =>
      questionService.fetchSyllabusIdByQuestionId(parseInt(questionId, 10)).pipe(
        switchMap((syllabusId) => {
          if (!syllabusId) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          const syllabus = syllabusQuery.getEntity(syllabusId);

          if (!syllabus) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          return of(
            router.createUrlTree([`/${CmsUrlParts.Syllabus}`, syllabus.slug, CmsUrlParts.Questions, questionId]),
          );
        }),
        catchError(() => of(router.createUrlTree([`/${CmsUrlParts.Overview}`]))),
      ),
    ),
  );
};
